module.exports = __webpack_public_path__ + "static/media/lcg-shape-dark-blue-flat.2866d41b.svg";